import _ from 'lodash';

class RegisterController {
  /* @ngInject */
  constructor($log, $rootScope, $scope, $filter, StorageService, MerchantDetailActions, LoginService, MerchantDetailStore, MerchantConfigurationService, MerchantDetailService, MerchantDeviceService, StoreStates, FoundationApi, StoreService) {
    const that = this;
    const REGISTER_DIALOG_ID = 'register_dialog';
    this.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
    var userContext;
    that.lista = [];
    that.loading = true;
    that.newCashSameNameError = false;
    that.onlyTablet = 0;
    that.isVas = false;
    that.registerDialog = {
      id: REGISTER_DIALOG_ID,
      title: 'titolo',
      text: '',
      isConfirm: false,
      closeFunc: {},
      confirmFunc: {}
    };

    this.onStoreSelected = () => {
      that.initListaMerchant();
    }


    that.checkSameName = () => {
      _.each(that.lista, (record) => {
        if (!that.newCashSameNameError) {
          that.newCashSameNameError = that.nomeCassa === record.merchantDeviceName;
        }
      });
    };

    // FUNZIONE PER APERTURA MODALI
    that.openRegisterDialog = (title, text, isConfirm, closeFunction, confirmFunction) => {
      const conf = isConfirm || false;
      const close = closeFunction || undefined;
      const confirm = confirmFunction || undefined;

      that.registerDialog = {
        id: REGISTER_DIALOG_ID,
        title,
        text,
        isConfirm: conf,
        closeFunc: close,
        confirmFunc: confirm
      };
      setTimeout(() => { FoundationApi.publish(REGISTER_DIALOG_ID, 'open'); }, 300);
    };

    // Servizio che recupera la lista della casse
    that.initListaMerchant = () => {
      this.userContext = JSON.parse(StorageService.getLocalStorage('userContext'));
      if(StoreService.getSavedStoreList().length > 0){
        that.loading = true;
        $log.debug(`Inizio caricamento Casse`);
        var selectedStore = StoreService.getSelectedStore() == undefined ? StoreService.getSavedStoreList()[0].id : StoreService.getSelectedStore().id;
        if (MerchantDetailStore.getMerchantDetailState() === StoreStates.STORE_EMPTY ||
            MerchantDetailStore.getMerchantDetailState() === StoreStates.STORE_EXPIRED ||
            MerchantDetailStore.getMerchantDetailState() === StoreStates.STORE_FAILED_UPDATE) {
          MerchantDetailActions.getMerchantDetail(this.userContext.business.id, selectedStore, false);
        } else if (MerchantDetailStore.getMerchantDetailState() === StoreStates.STORE_VALID) {
          const res = MerchantDetailStore.getMerchantDetail();
          that.lista = res;
          that.loading = false;
        }
        LoginService.getMerchantProfile().then((result) => {
          that.intestazione = result.intestazione;
        });
        that.checkOnlyTablet();
      }else{
        that.loading = false;
      }
    };


    // funzione che verifica l'attivazione del Vas e la presenza di casse Tablet attive
    that.checkOnlyTablet = () => {
      that.onlyTablet = 0;
      MerchantConfigurationService.getMerchantStoreConfiguration().then((settings) => {
        if (settings.isVasMerchant && (settings.services.orderAndPay || settings.services.checkin)) {
          that.isVas = true;
          _.each(that.lista, (record) => {
            that.onlyTablet = record.tablet && record.state === 'ENABLED' ? that.onlyTablet + 1 : that.onlyTablet;
          });
        } else {
          that.isVas = false;
        }
      }, (reason) => {
        $log.error('ServicesActivationsController', 'loadSettings', reason);
      });
    };


    that.initListaMerchant();

    that.getLabelCassa = (state) => {
      let retval = '';
      switch (state) {
        case 'ENABLED':
          retval = 'shop.register.device.state.enabled';
          break;
        case 'PENDING':
          retval = 'shop.register.device.state.pending';
          break;
        case 'DISABLED':
          retval = 'shop.register.device.state.disabled';
          break;
        default:
          retval = 'shop.register.device.state.default';
      }
      return retval;
    };


    that.cassaPrincipale = (object) => {
      /*if (that.isSuperAdmin) {
        return;
      }*/
      let title;
      let text;
      let isconfirm;
      let close;
      let confirm;

      if (!object.standalone) {
        if (object.status === 'DISABLED' || object.status === 'PENDING') {
          title = $filter('translate')(`shop.register.modal.errortitle`);
          text = $filter('translate')(`shop.register.modal.disabledcash.text1`) + object.deviceName + $filter('translate')(`shop.register.modal.disabledcash.text2`);
          isconfirm = false;
        } else {
          if (!that.onlyTablet || object.tablet) {
            title = $filter('translate')(`shop.register.modal.newmaincash.title`);
            text = $filter('translate')(`shop.register.modal.newmaincash.text1`) + object.deviceName + $filter('translate')(`shop.register.modal.newmaincash.text2`);
            isconfirm = true;
            confirm = () => {
              that.updateCassa(object.id, object.status, true);
            };
          } else {
            title = $filter('translate')(`shop.register.modal.errortitle`);
            text = $filter('translate')(`shop.register.modal.nottabletcash.text`);
            isconfirm = false;
          }
        }
      } else if (object.standalone) {
        if (that.onlyTablet !== 1) {
          title = $filter('translate')(`shop.register.modal.deletemaincash.title`);
          text = $filter('translate')(`shop.register.modal.deletemaincash.text1`) + object.deviceName + $filter('translate')(`shop.register.modal.deletemaincash.text2`);
          isconfirm = true;
          confirm = () => {
            that.updateCassa(object.id, object.status, false);
          };
        } else {
          title = $filter('translate')(`shop.register.modal.errortitle`);
          text = $filter('translate')(`shop.register.modal.onlyonetabletcash.text`);
          isconfirm = false;
        }
      }
      that.openRegisterDialog(title, text, isconfirm, close, confirm);
    };


    that.enableDevice = (cassa) => {
      if (cassa.standalone) {
        const title = $filter('translate')(`shop.register.modal.errortitle`);
        const text = $filter('translate')(`shop.register.modal.disableerrormain.text`);
        const isconfirm = false;
        that.openRegisterDialog(title, text, isconfirm, close, confirm);
      } else {
        if (cassa.status === 'PENDING') {
          const title = $filter('translate')(`shop.register.modal.errortitle`);
          const text = $filter('translate')(`shop.register.modal.pendingregistry.text`);
          const isconfirm = false;
          that.openRegisterDialog(title, text, isconfirm, close, confirm);
        } else {
          cassa.status = cassa.status === "ENABLED" ? "DISABLED" : "ENABLED";  // eslint-disable-line
          // se le funzionalità vas sono attivate e nessuna cassa tablet è attualmente attiva e questa è una cassa tablet
          // (questa è la prima cassa tablet ad essere attivata dopo aver attivato i servizi Vas)
          // allora la devo settare come principale

          const setAsPrincipal = that.isVas && !that.onlyTablet && cassa.tablet;
          that.loading = setAsPrincipal;
          MerchantConfigurationService.updateMerchantDevice(cassa.id, cassa.status, setAsPrincipal, true).then(
            (r) => {
              $log.debug(r);
              if (setAsPrincipal) {
                MerchantDetailActions.getMerchantDetail(this.userContext.business.id, StoreService.getSelectedStore().id, true).finally(() => {
                  that.loading = false;
                });
              }
              that.checkOnlyTablet();
            },
            (reject) => {
              cassa.state = cassa.state === "ENABLED" ? "DISABLED" : "ENABLED";  // eslint-disable-line
              $log.error(reject);
              that.loading = false;
            });
        }
      }
    };

    that.deleteCassa = (id) => {
      that.loading = true;
      MerchantConfigurationService.deleteMerchantDevice(id).then((r) => {
        $log.debug(r);
        MerchantDetailActions.getMerchantDetail(this.userContext.business.id, StoreService.getSelectedStore().id, true);
      },
      (reject) => {
        $log.error(reject);
        that.loading = false;
      });
    };

    that.updateCassa = (id, stato, principale) => {
      that.loading = true;
      MerchantConfigurationService.updateMerchantDevice(id, stato, principale, true).then((r) => {
        $log.debug(r);
        MerchantDetailActions.getMerchantDetail(this.userContext.business.id, StoreService.getSelectedStore().id, true);
      },
      (reject) => {
        $log.error(reject);
        that.loading = false;
      });
    };
    that.openDelete = () => {
      if (!this.deleteMode) {
        this.deleteMode = true;
      } else {
        this.deleteMode = false;
        _.each(this.lista, (cassa) => {
          cassa.deleteMode = false;  // eslint-disable-line
        });
      }
    };
    that.eliminaCassa = (object) => {
      let title;
      let text;
      let isconfirm;
      let close;
      let confirm;

      if (!object.standalone) {
        title = $filter('translate')(`shop.register.modal.deletecash.title`);
        text = `${$filter('translate')('shop.register.modal.deletecash.text1', { name: object.deviceName })} ${$filter('translate')('shop.register.modal.deletecash.text2')}`;
        isconfirm = true;
        confirm = () => {
          that.deleteCassa(object.id);
        };
      } else {
        title = $filter('translate')(`shop.register.modal.errortitle`);
        text = `${$filter('translate')('shop.register.modal.deleteerrormain.text1')} ${object.deviceName} ${$filter('translate')('shop.register.modal.deleteerrormain.text2')}`;
        isconfirm = false;
      }
      that.openRegisterDialog(title, text, isconfirm, close, confirm);
    };
    that.qrCode = (object) => {
        MerchantConfigurationService.qrCode(object.id);
    };
    that.generaCodice = () => {
      if (that.formCassa.$valid) {
        $log.debug(`Nome cassa ${that.nomeCassa}`);
        that.loading = true;
        var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
        MerchantDeviceService.generateNewAppMerchant(that.nomeCassa, false, merchantProfile.business.id, false).then((r) => {
          $log.debug(`response generateNewAppMerchant ${r}`);
          MerchantDetailActions.getMerchantDetail(merchantProfile.business.id, StoreService.getSelectedStore().id, false);
        }, (error) => {
          $log.error(error);
          that.loading = false;
        });
      } else {
        that.erroreNomeCassa = that.formCassa.nome.$invalid;
      }
    };


    const deRegRefreshListener = $scope.$on(`MERCHANT_DETAIL_UPDATE`, () => {
      that.loading = true;
      const res = MerchantDetailStore.getMerchantDetail();
      that.lista = res;
      that.checkOnlyTablet();
      that.loading = false;
    });

    $scope.$on(`$destroy`, () => {
      deRegRefreshListener();
    });
  }
}

export default RegisterController;



/** WEBPACK FOOTER **
 ** ./client/app/components/shop/register/register.controller.js
 **/